/* angular:styles/component:css;108e142ab8971df4;/home/runner/work/app/app/src/app/components/coach/coach-launcher/coach-launcher.component.ts */
:host {
  display: contents;
}
.coach-preview {
  position: fixed;
  z-index: 9000;
  left: var(--coach-preview-left, 1rem);
  bottom: var(--coach-preview-bottom, 1rem);
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  max-width: min(22rem, calc(100vw - 2rem));
  padding: 0.625rem 0.5rem 0.625rem 0.875rem;
  border-radius: 0.75rem;
  background: var(--surface-primary, var(--background-color));
  color: var(--text-color);
  border: 1px solid color-mix(in srgb, var(--accent-color, #ff5322) 45%, transparent);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.22);
  font-size: 0.8125rem;
  line-height: 1.4;
}
.coach-preview-open {
  flex: 1;
  min-width: 0;
  padding: 0;
  border: none;
  background: none;
  color: inherit;
  font: inherit;
  text-align: start;
  cursor: pointer;
}
.coach-preview-open:focus-visible,
.coach-preview-close:focus-visible {
  outline: 2px solid var(--accent-color);
  outline-offset: 2px;
}
.coach-preview-close {
  flex: none;
  width: 1.5rem;
  height: 1.5rem;
  border: none;
  border-radius: 0.375rem;
  background: none;
  color: var(--text-secondary);
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
}
/*# sourceMappingURL=coach-launcher.component-W22DSKDX.css.map */
